import React from 'react';

import NoOrganisationAccess from '../components/NoOrganisationAccess/NoOrganisationAccess';
import OrdersRedirect from '../components/Order/components/Redirect';
import AppLessMyAccount from '../components/Profile/AppLessMyAccount';
import Portal from '../layouts/Portal/Portal';
import { accountRoutesConst, publicRoutes } from './account.routes';

const privateRoutes: (RoutePropsExtended | RedirectPropsExtended)[] = [
  {
    name: 'orders.redirect',
    group: 'private',
    path: '/orders',
    component: OrdersRedirect,
    exact: true,
  },
  {
    name: 'my_account',
    group: 'private',
    path: accountRoutesConst.MyAccount,
    component: AppLessMyAccount,
    exact: true,
  },
  {
    name: 'no_organisation_access',
    group: 'private',
    path: accountRoutesConst.NoOrganisationAccess,
    component: NoOrganisationAccess,
    exact: true,
  },

  {
    name: 'portal',
    group: 'private',
    path: '/:appId?',
    component: Portal,
  },
];

const exportedRoutes = {
  publicRoutes,
  privateRoutes,
};

export default exportedRoutes;

export const defaultRoutingRoutesState: (RoutePropsExtended | RedirectPropsExtended)[] = [
  ...publicRoutes,
  ...privateRoutes,
];
